import { useState, useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { useQuizMeSession } from '../utils/quizMeUtils';
export const useDisplayInteractiveEducation = (interactiveContentTrackingProps, videoId) => {
  const [displayInteractiveEducation, setDisplayInteractiveEducation] = useState();
  const {
    setQuizMeClickTimestamp
  } = useQuizMeSession();
  useEffect(() => {
    setDisplayInteractiveEducation(undefined);
  }, [videoId, interactiveContentTrackingProps.id]);
  const handleDisplayInteractiveEducation = flag => {
    const action = (() => {
      switch (flag) {
        case 'QUIZ_ME':
          return 'ai-quiz-me-button-clicked';
        case 'SUMMARIZATION':
          return 'ai-summarize-button-clicked';
        case 'ADAPT_TO_INDUSTRY':
          return 'ai-adapt-to-industry-button-clicked';
        default:
          return 'ai-summarize-button-clicked';
      }
    })();
    if (interactiveContentTrackingProps) {
      if (flag === 'QUIZ_ME') {
        setQuizMeClickTimestamp({
          contentType: interactiveContentTrackingProps.contentType === 'SHORT_FORM_CONTENT' ? 'SHORT_FORM_CONTENT' : 'LESSON',
          contentId: interactiveContentTrackingProps.id
        });
      }
      UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, interactiveContentTrackingProps, {
        action
      }));
    }
    setDisplayInteractiveEducation(prev => prev === flag ? undefined : flag);
  };
  return {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation
  };
};